import BaseService from './base-service';

const GET_CONFIGS_URL = '/api/v1/events/{{eid}}/integration-configs';

/**
 * Provides a facility to monitor the status of a specific running job.
 *
 * @example
 * import IntegrationsService from 'libs/services/integrations';
 * ...
 * const integrations = new IntegrationsService();
 */
export default class IntegrationsService extends BaseService {
    /**
     * Returns fields for all available integrations
     *
     * @param {String} eid
     * @returns {Promise<{{_id:string;name:string;fields:string[];searchable:string[]}[]}>}
     */
    async getIntegrationConfigs(eid) {
        const url = this.buildUrl(GET_CONFIGS_URL, { eid });
        const { data } = await this.get(url);
        return data;
    }
}
